import React from 'react';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Contacta con nosotros</h4>
          <p><i className="fas fa-phone"></i>3215886925</p>
          <p><i className="fas fa-envelope"></i>cybersofiacontacto@gmail.com</p>
          <p><i className="fas fa-map-marker-alt"></i>Cl. 5 #4-82</p>
        </div>
        <div className="footer-section">
          <h4>Enlaces rápidos</h4>
          <ul>
        
           {/* <li><a href="#services">Servicios</a></li>*/}
            <li><Link to="/about">Nosotros</Link></li>
          <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contacto</Link></li>
          </ul>
        </div>
        <div className="footer-section whatsapp-section">
          <a
            href="https://wa.me/+573215886925"
            className="whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i>Chatea con nosotros en WhatsApp
          </a>
        </div>
        <div className="footer-section">
          <h4>Síganos</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/admincibersofia/?viewas=100000686899395"><i className="fab fa-facebook-f">Facebook</i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
     
      </div>
      <div className="footer-bottom">
        &copy; 2025 Centro de servicios. Reservados todos los derechos.
      </div>
    </footer>
  );
}

export default Footer;
